





























import { mapGetters } from 'vuex';

import {
  getShowOnlyStreamersConfiguration,
  updateShowOnlyStreamersConfiguration
} from '@/api/CopyStake/Settings';
import {
  TCopyStakeSettingsShowOnlyStreamersPayload,
  TCopyStakeSettingsShowOnlyStreamersResponse
} from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import type { AxiosError } from 'axios';

const ConfirmationDialog = (): Promise<any> =>
  import('@/components/ConfirmationDialog.vue');

export default {
  name: 'CopyStakeSettingsShowOnlyStreamers',
  components: {
    ConfirmationDialog
  },
  data(): any {
    return {
      showOnlyStreamers: false,

      showConfirm: false,
      confirmData: {
        cancelText: 'Cancel',
        okText: `Yes, I'm sure`,
        header: 'Show only streamers',
        disclaimer: 'Are you sure you want to enable this feature?',
        okButtonType: 'primary'
      },

      isLoading: false
    };
  },
  props: {
    title: {
      type: String,
      default: (): string => ''
    }
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    handleStreamerChange(): void {
      if (this.isLoading || !this.canEdit) return;

      if (!this.showOnlyStreamers) {
        this.showConfirm = true;
      } else {
        this.updateConfiguration(true);
      }
    },
    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getShowOnlyStreamersConfiguration()
        .then((data: TCopyStakeSettingsShowOnlyStreamersResponse) => {
          this.showOnlyStreamers = data;
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateConfiguration(): Promise<void> {
      this.isLoading = true;

      const payload: TCopyStakeSettingsShowOnlyStreamersPayload = {
        active: !this.showOnlyStreamers
      };

      await updateShowOnlyStreamersConfiguration(payload)
        .then(() => {
          this.showOnlyStreamers = payload.active;

          this.$toast.success(
            'Show only streamers was successfully updated!'
          );
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.showConfirm = false;
          this.isLoading = false;
        });
    }
  }
};
